<template>
  <v-card>
    <v-card-title>
      <v-toolbar-title>
        <v-icon left>mdi-camera-control</v-icon>
        Comparar cobranza de Yaku vs Dbf
      </v-toolbar-title>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-btn @click="listar" :loading="loading">Listar</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-tabs
          fixed-tabs
          dark
          v-model="tab"
        >
          <v-tab value="otros">OTROS INGRESOS</v-tab>
          <v-tab value="consumo">CONSUMO</v-tab>
          <v-tab value="ingresados">INGRESADOS</v-tab>
        </v-tabs>
      </v-row>
      <br>
        <v-tabs-items v-model="tab">
          <v-tab-item key="otros">
            <v-row>
              <v-col cols="12" md="6">
                <h2>Cobranza Otros Ingresos <v-icon>mdi-arrow-down-right-bold</v-icon></h2>
                <v-row>
                  <v-col>
                    <v-simple-table>
                      <thead>
                        <th>Nro.</th>
                        <th>Nro Factura</th>
                        <th>Monto</th>
                        <th>Concepto</th>
                        <th>Codigo</th>
                        <th>Fecha</th>
                        <th>Cuenta</th>
                        <th>Cajero</th>
                        <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in datos_cobranza" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.numero_factura }}</td>
                          <td>{{ item.total }}</td>
                          <td>{{ item.concepto }}</td>
                          <td>{{ item.codigo_tramite }}</td>
                          <td>{{ item.fecha }}</td>
                          <td>{{ item.cuenta }}</td>
                          <td>{{ item.ventanilla }}</td>
                          <td>
                            <v-btn @click="ver(item.detalle)" color="success" icon><v-icon>mdi-eye</v-icon></v-btn>
                            <v-btn @click="igualar(item, 'Cobranza')" color="primary" icon><v-icon>mdi-pencil</v-icon></v-btn></td>
          
                        </tr>
                        <tr v-if="datos_detalles.length > 0">
                          <td></td>
                          <td colspan="6">OTROS INGRESOS SIN PAGINGRE</td>
                            <v-btn @click="verTodos()" color="success" icon><v-icon>mdi-eye</v-icon></v-btn>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                
              </v-col>

              <v-col cols="12" md="6">
                <h2>Detalles Otros Ingresos <v-icon>mdi-arrow-down-right-bold</v-icon></h2>
                <v-simple-table>
                  <thead>
                    <th>Nro.</th>
                    <th>Nro Factura</th>
                    <th>Monto</th>
                    <th>Tipo</th>
                    <th>Fecha</th>
                    <th>Cuenta</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in detalles" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.num_fact }}</td>
                      <td>{{ item.monto }}</td>
                      <td>{{ item.codi }}</td>
                      <td>{{ item.concepto }}</td>
                      <td>{{ item.matricula }}</td>
                      <td><v-btn @click="igualar(item, 'Detalle')"><v-icon>mdi-pencil</v-icon></v-btn></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
  
            </v-row>
          </v-tab-item>
          <v-tab-item key="consumo">
            <v-row>
              <v-col cols="12" md="6">
                <h2>Consumo Pago<v-icon>mdi-arrow-down-right-bold</v-icon></h2>
                <v-simple-table>
                  <thead>
                    <th>Nro.</th>
                    <th>Nro Factura</th>
                    <th>Monto</th>
                    <th>Nfac</th>
                    <th>Fecha</th>
                    <th>Cuenta</th>
                    <th>Cajero</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in datos_consumo" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.numero_factura }}</td>
                      <td>{{ item.total }}</td>
                      <td>{{ item.nfac }}</td>
                      <td>{{ item.fecha }}</td>
                      <td>{{ item.cuenta }}</td>
                      <td>{{ item.ventanilla }}</td>
                      <td><v-btn @click="igualar(item, 'Consumo')"><v-icon>mdi-pencil</v-icon></v-btn></td>
  
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="6">
                <h2>Consumo Planilla<v-icon>mdi-arrow-down-right-bold</v-icon></h2>
                <v-simple-table>
                  <thead>
                    <th>Nro.</th>
                    <th>Nro Factura</th>
                    <th>Monto</th>
                    <th>Nfac</th>
                    <th>Fecha</th>
                    <th>Cuenta</th>
                    <th>Cajero</th>
                    <th>Anulado</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in datos_planilla" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.numero_factura }}</td>
                      <td>{{ item.total }}</td>
                      <td>{{ item.nfac }}</td>
                      <td>{{ item.fecha }}</td>
                      <td>{{ item.cuenta }}</td>
                      <td>{{ item.ventanilla }}</td>
                      <td> <v-chip :color="item.es_anulado ? 'red':'green'" dark>
                          {{ item.es_anulado ? 'SI':'NO' }}
                      </v-chip> </td>
                      <td><v-btn :disabled="item.es_anulado" @click="igualar(item, 'Consumo')"><v-icon>mdi-pencil</v-icon></v-btn></td>
  
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            
          </v-tab-item>
          <v-tab-item key="ingresados">
            <v-row>
              <v-col cols="12" md="4">
                <v-simple-table>
                  <thead >
                    <tr style="background-color: #C5CAE9;">
                      <th colspan="6" class="text-h5 text-center">Consumo</th>
                    </tr>
                    <tr>
                      <th>Num.</th>
                      <th>Numero Factura</th>
                      <th>Cuenta</th>
                      <th>Razon Social</th>
                      <th>Monto</th>
                      <th>Nfac</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dato, index) in consumos" :key="dato.id">
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'ConsumoAgua'">{{ index + 1  }}</td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'ConsumoAgua'">{{ dato.cobranza.numero_factura  }}</td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'ConsumoAgua'">{{ dato.cobranza.cuenta  }}</td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'ConsumoAgua'">{{ dato.cobranza.razon_social  }}</td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'ConsumoAgua'">{{ dato.cobranza.total  }}</td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'ConsumoAgua'">{{ dato.cobranza.nfac  }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="8">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th colspan="5" class="text-h5 text-center" style="background-color: #D1C4E9;">Otros Ingresos</th>
                      <th colspan="5" class="text-h5 text-center" style="background-color: #BBDEFB;">Detalle</th>

                    </tr>
                    <tr>
                      <th>Numero Factura</th>
                      <th>Cuenta</th>
                      <th>Razon Social</th>
                      <th>Monto</th>
                      <th>Tramite</th>

                      <th>Num Fact</th>
                      <th>Codi</th>
                      <th>Matricula</th>
                      <th>Monto</th>
                      <th>Concepto</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dato) in datos_ingresados" :key="dato.id">

                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'OtroServicio'">{{ dato.cobranza.numero_factura }}</td> <td v-else></td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'OtroServicio'">{{ dato.cobranza.cuenta }}</td> <td v-else></td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'OtroServicio'">{{ dato.cobranza.razon_social }}</td> <td v-else></td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'OtroServicio'">{{ dato.cobranza.total }}</td> <td v-else></td>
                      <td v-if="dato.cobranza_id && dato.cobranza.tipo == 'OtroServicio'">{{ dato.cobranza.concepto }}</td> <td v-else></td>

                      <td v-if="dato.detalle_id">{{ dato.detalle.num_fact }}</td> <td v-else></td>
                      <td v-if="dato.detalle_id">{{ dato.detalle.codi }}</td> <td v-else></td>
                      <td v-if="dato.detalle_id">{{ dato.detalle.matricula }}</td> <td v-else></td>
                      <td v-if="dato.detalle_id">{{ dato.detalle.monto }}</td> <td v-else></td>
                      <td v-if="dato.detalle_id">{{ dato.detalle.concepto }}</td> <td v-else></td>

                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
    </v-card-text>

  </v-card>
</template>
<script>
import {DateTime} from "luxon";
import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
export default {
  name: "ComprobarIndex",
  data() {
    return {
      fechaDesde: DateTime.local().toFormat("yyyy-MM-dd"),
      fechaHasta: DateTime.local().toFormat("yyyy-MM-dd"),
      dateTime: DateTime.local().toFormat("yyyy-MM-dd 00:00:00"),
      rules: [
        value => {
          if (value) return true
          return 'You must enter a first name.'
        },
      ],
      datos_cobranza: [],
      datos_detalles: [],
      datos_consumo: [],
      detalles: [],
      datos_planilla: [],
      datos_ingresados: [],
      loading: false,
      tab: null
    };
  },
  mounted() {
    this.listar()
  },
  computed: {
    consumos() {
      let datos = []
      datos = this.datos_ingresados.filter((item) => 
        item.cobranza_id && item.cobranza.tipo == 'ConsumoAgua'
      )

      return datos;
    }
  },
  methods: {

    listar() {
      this.loading = true
      this.datos_cobranza = [];
      this.datos_detalles = [];
      this.datos_consumo = [];
      this.detalles = [];
      this.datos_planilla = [];
      http.get("/comparar-cobranza").subscribe({
        next: (response) => {
          this.loading = false
          if (response.data.success) {
            this.datos_cobranza = response.data.cobranza;
            this.datos_detalles = response.data.detalles;
            this.datos_consumo = response.data.consumo;
            this.datos_planilla = response.data.planilla;
            this.datos_ingresados = response.data.ingresados;
          } else {
            Alert.error(response.data.message)
          }
        },
        error: (error) => {
          console.log(error);
        },
      });
    },
    igualar(item, tipo) {
      this.loading = true
      const url = tipo == 'Detalle' ? "/igualar-pago":"/igualar-pago-completo";
      Alert.confirm("¿Desea igualar el pago?").then((response) => {
        if (response.isConfirmed) {
          http.post(url , {
            id: item.id,
            tipo: tipo,
            detalles: item.detalle?item.detalle:[]
          }).subscribe({
            next: (response) => {
              this.loading = false
              if (response.data.success) {
                Alert.success(response.data.message)
                this.listar()
              } else {
                Alert.error(response.data.message)
              }
            },
            error: (error) => {
              console.log(error);
            },
          });
          
        }this.loading = false
      })
    },
    ver(det) {
      this.detalles = [];
      this.detalles = det
    },
    verTodos(){
      this.detalles = this.datos_detalles;
    },
  }
}
</script>

<style scoped>

</style>